module.exports = __webpack_public_path__ + "img/梁庄镇.336a119a.png";